import React from "react";
import { Banknote, Smartphone, CreditCard, Wallet } from "lucide-react";

export const PAY_MODES = [
  { key: "CASH", label: "Cash", icon: Banknote },
  { key: "UPI", label: "UPI", icon: Smartphone },
  { key: "CARD", label: "Card", icon: CreditCard },
  { key: "OTHER", label: "Other", icon: Wallet },
];

/** The booking's "Payment Details" text as a payment mode (DD / Cheque and the like are Other). */
export const toPayMode = (v) => {
  const s = String(v || "").trim().toUpperCase();
  if (!s) return "CASH";
  return PAY_MODES.some((m) => m.key === s) ? s : "OTHER";
};

/** Cash / UPI / Card / Other buttons: how the money was collected (adds up in the Shift-wise DCR Closing). */
export default function PaymentModePicker({ value, onChange, testid = "pay-mode" }) {
  return (
    <div data-testid={testid}>
      <p className="text-xs font-semibold text-slate-700 mb-1">Payment Mode</p>
      <div className="grid grid-cols-4 gap-1.5">
        {PAY_MODES.map(({ key, label, icon: Icon }) => (
          <button key={key} type="button" onClick={() => onChange(key)} data-testid={`${testid}-${key.toLowerCase()}`}
            className={`h-10 rounded-md border text-sm font-semibold flex items-center justify-center gap-1.5 transition-colors ${value === key
              ? "bg-maroon-700 border-maroon-700 text-white shadow-sm" : "bg-white border-[#E5D9C5] text-slate-700 hover:bg-gold-50"}`}>
            <Icon className="w-4 h-4" />{label}
          </button>
        ))}
      </div>
    </div>
  );
}
